<button
	*ngIf="showSidebarToggle && filterLayout === 'horizontal'"
	mat-stroked-button
	color="neutral"
	class="icon-only button-big mr-2"
	(click)="toggleSidebar.emit()"
><mat-icon>filter_list</mat-icon></button>

<ng-container *ngFor="let filter of relevantFilters; let i = index; trackBy: trackByFn">
	<app-filter-input
		*ngIf="!filter.hidden"
		[style.flex-grow]="filter.grow === false ? 0 : (filter.growAmount || 1)"
		[style.min-width]="filter.minWidth ? filter.minWidth + 'px' : ''"
		[class.no-top-padding]="filter.topPadding === false"
		[filter]="filter"
		[formGroup]="form"
		(update)="updateQueryParam($event)"
	></app-filter-input>

	<div *ngIf="filter.breakAfter" [style.flex-basis]="'100%'"></div>
</ng-container>

<ng-content></ng-content>
